// Allannouncements.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import CustomNavbar from "./CustomPermissions/CustomNavbar";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";

const Allannouncements = (props) => {

  const [announcements, setAnnouncements] = useState([]);

  const [editingAnnouncement, setEditingAnnouncement] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleEdit = (announcement) => {
    setEditingAnnouncement(announcement);
    setIsEditing(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        getApiUrl(`/edit_announcement/${editingAnnouncement.id}/`),
        editingAnnouncement,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setAnnouncements((prevAnnouncements) =>
        prevAnnouncements.map((announcement) =>
          announcement.id === editingAnnouncement.id
            ? response.data
            : announcement
        )
      );

      setIsEditing(false);
      setEditingAnnouncement(null);
    } catch (error) {
      console.error("Error updating announcement:", error);
    }
  };

  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2); // 0-padded month
    const day = `0${date.getDate()}`.slice(-2); // 0-padded day
    const hours = `0${date.getHours()}`.slice(-2); // 0-padded hours
    const minutes = `0${date.getMinutes()}`.slice(-2); // 0-padded minutes
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    if (name === "activity_date") {
      setEditingAnnouncement((prev) => ({
        ...prev,
        [name]: formatDateForInput(value),
      }));
    } else {
      setEditingAnnouncement((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const location = useLocation();
  const additionalData = location.state?.additionalProp;

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await axios.get(
          getApiUrl("/ShowAnnouncements/"),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        ); // Replace with your API endpoint
        setAnnouncements(response.data);

      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    };

    fetchAnnouncements();
  }, []);

  const formatDateTime = (datetimeString) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(datetimeString).toLocaleString(undefined, options);
  };

  const handleDelete = async (id) => {
    try {
      const userConfirmed = window.confirm("Are you sure you want to delete?");

      if (userConfirmed) {
        await axios.delete(getApiUrl(`/DeleteAnnouncement/${id}/`), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`, // Replace with your actual token retrieval logic
          },
        });

        setAnnouncements((prevAnnouncements) =>
          prevAnnouncements.filter((announcement) => announcement.id !== id)
        );
      }
    } catch (error) {
      console.error("Error deleting announcement:", error);
    }
  };

  const [isSuperuser, setIsSuperuser] = React.useState(false);
  const [isTeamLeader, setIsTeamLeader] = React.useState(false);

  React.useEffect(() => {
    const superuserStatus = localStorage.getItem("is_superuser") === "true";
    setIsSuperuser(superuserStatus);
    
    const userPermissions = JSON.parse(localStorage.getItem("permissions")) || [];
    const isLeader = userPermissions.includes("auth.Custom_team_leader_perm");
    setIsTeamLeader(isLeader);
  }, []);

  return (
    <div style={{ display: "flex" }}>
      {props.dataProp === "viewer_permission" ? (
        <></>
      ) : (
        <CustomNavbar />
      )}

      <div style={{ width: "100%", padding: "20px" }} className="mt-2 ">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "90%",
              margin: "auto",
            }}
          >
            <h2
              className="text-blue-500"
              style={{
                marginLeft: "45px",
                // color: "var(--bs-blue)",
                marginTop: "10px",
              }}
            >
              Announcement
            </h2>

            {/* Hide Create Announcement button for Team Leaders */}
            {!isTeamLeader && (
              <Link to="/createannouncements">
                <button
                  className="bg-blue-500 p-2 text-white"
                  style={{ borderRadius: "5px" }}
                >
                  Create Announcement
                </button>
              </Link>
            )}
          </div>

          <table
            className="min-w-full mt-3 bg-white "
            style={{ width: "90%", margin: "auto" }}
          >
            <thead>
              <tr className="bg-blue-500">
                <th scope="col" className="py-2 px-4 border-b">
                  #
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Title
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Description
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Announcement Date
                </th>
                {/* <th scope="col" className="py-2 px-4 border-b">Announced By</th> */}
                <th scope="col" className="py-2 px-4 border-b">
                  Expiry Date
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Options
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300 text-center">
              {announcements.map((announcement, index) => (
                <tr key={announcement.id}>
                  <td className="py-2 px-4 border-b">{index + 1}</td>
                  <td className="py-2 px-4 border-b">{announcement.title}</td>

                  <td className="py-2 px-4 border-b">{announcement.name}</td>
                  <td className="py-2 px-4 border-b">
                    {formatDateTime(announcement.dateadded)}
                  </td>
                  {/* <td className="py-2 px-4 border-b">{announcement.byuser}</td> */}
                  <td className="py-2 px-4 border-b">
                    {formatDateTime(announcement.activity_date)}
                  </td>
                  <td className="py-2 px-4 border-b">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <button
                        className="btn"
                        style={{
                          padding: "15px",
                          background: "#F59E0B",
                          marginRight: "10px",
                        }}
                        onClick={() => handleEdit(announcement)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-pencil-fill"
                          viewBox="0 0 16 16"
                          color="#fff"
                        >
                          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                        </svg>
                      </button>
                      <button
                        className="btn"
                        style={{ padding: "15px", background: "#3b82f6" }}
                        onClick={() => handleDelete(announcement.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-trash-fill"
                          viewBox="0 0 16 16"
                          color="#fff"
                        >
                          <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}

              {isEditing && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                  <div
                    className="absolute inset-0 bg-gray-800 bg-opacity-60 backdrop-blur-sm"
                    style={{
                      width: "100vw",
                      height: "150%",
                      background: "black",
                      backgroundSize: "200% 200vh",
                      overflowY: "hidden",
                      paddingBottom: "150px",
                    }}
                  ></div>
                  <div
                    className="relative bg-white w-4/5 max-w-4xl rounded-lg shadow-lg"
                    style={{
                      // marginTop: "50px",
                      height: "95vh", // Set height to allow scrolling
                      overflowY: "auto", // Enable scrolling inside modal
                    }}
                  >
                    <div
                      className="overflow-auto max-h-[80vh]"
                      style={{ padding: "100px", paddingTop: "20px" }}
                    >
                      <h2 className="text-xl font-bold mb-4">
                        Edit Announcement
                      </h2>
                      <form onSubmit={handleEditSubmit}>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700">
                            Title
                          </label>
                          <input
                            type="text"
                            name="title"
                            value={editingAnnouncement.title}
                            onChange={handleEditChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700">
                            Description
                          </label>
                          <textarea
                            name="name"
                            value={editingAnnouncement.name}
                            onChange={handleEditChange}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            cols="53"
                            rows="7"
                            style={{ resize: "none", wordWrap: "break-word" }} // Prevent resizing and allow word break
                          />
                        </div>

                        <input
                          type="datetime-local"
                          name="activity_date"
                          value={formatDateForInput(
                            editingAnnouncement.activity_date
                          )}
                          onChange={handleEditChange}
                          className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />

                        <div className="flex justify-end mt-3">
                          <button
                            type="button"
                            onClick={() => setIsEditing(false)}
                            className="mr-2 px-4 py-2 bg-gray-500 text-white rounded-md"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="px-4 py-2 bg-blue-500 text-white rounded-md"
                          >
                            Save
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </tbody>
          </table>
      </div>
    </div>
  );
};

export default Allannouncements;
